"use client"
import {createNavigation} from 'next-intl/navigation';
import {routing} from './routing';
import { useMainAppStore } from '../modules/shared/stores/mainAppStore';
import { ComponentProps } from 'react';
import React from 'react';
 
// Lightweight wrappers around Next.js' navigation
// APIs that consider the routing configuration
const {Link: BaseLink, redirect, usePathname, useRouter, getPathname} =
  createNavigation(routing);

// Wrapped Link component that toggles NavProgressBar state on click
const Link = (props: ComponentProps<typeof BaseLink>) => {
  const { toggleNavProgressBar } = useMainAppStore();
  const currentPathname = usePathname();
  
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Check if the href matches the current pathname
    const href = props.href;
    const isCurrentPage = href === currentPathname || 
                         (typeof href === 'string' && href.startsWith(currentPathname + '?'));
    
    // Only toggle progress bar if navigating to a different page
    if (!isCurrentPage) {
      toggleNavProgressBar();
    }
    
    // Call the original onClick if it exists
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return React.createElement(BaseLink, { ...props, onClick: handleClick });
};

export { Link, redirect, usePathname, useRouter, getPathname };